import React, { Component } from 'react';
import PropTypes from "prop-types";
import M from 'materialize-css';
import { connect } from "react-redux";
import { Link, withRouter } from 'react-router-dom';

const AdminMenuItems = {
    'appointments': { link: '/admin/appointments', label: 'Consultas' },
    'sliders': { link: '/admin/sliders', label: 'Sliders' },
    'testimonials': { link: '/admin/testimonials', label: 'Testimoniales' }
}

class Header extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };
    componentDidMount() {
        let sidenav = document.querySelectorAll('.sidenav');
        M.Sidenav.init(sidenav, {});
    }
    handleClick() {
        let instance = M.Sidenav.getInstance(document.querySelector('.sidenav'));
        instance.close();
    }
    render() {
        const renderLinks = () => {
            if(this.props.hasValidToken && this.props.user)
                return Object.keys(AdminMenuItems).map(key => {
                    return (
                        <li key={key} target='_blank'>
                            <Link to={AdminMenuItems[key].link} onClick={this.handleClick}>{AdminMenuItems[key].label}</Link>
                        </li>
                    )
                })
            return null;
        };
        return (
            <div>
                <nav className="page-header brand-color">
                    <div className="nav-wrapper">
                        <Link to="/" className="brand-logo">
                            <img alt="Centro IntusRenacer" src={`${process.env.REACT_APP_CLOUDFRONT}/img/header.png`} />
                        </Link>
                        <Link to="/" data-target="mobile-demo" className="sidenav-trigger"><i className="material-icons">menu</i></Link>
                        <ul id="nav-mobile" className="right hide-on-med-and-down nav-mobile">
                            <li><Link to="/">Inicio</Link></li>
                            { renderLinks() }
                            <li><Link to="/about">Nosotros</Link></li>
                            <li><Link to="/services">Servicios</Link></li>
                            <li><Link to="/contact">Contacto</Link></li>
                        </ul>
                    </div>
                </nav>
                <ul className="sidenav" id="mobile-demo">
                    <li><Link to="/" onClick={this.handleClick}>Inicio</Link></li>
                    { renderLinks() }
                    <li><Link to="/about" onClick={this.handleClick}>Nosotros</Link></li>
                    <li><Link to="/services" onClick={this.handleClick}>Servicios</Link></li>
                    <li><Link to="/contact" onClick={this.handleClick}>Contacto</Link></li>
                </ul>
            </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.app.user,
        hasValidToken: state.app.expiration_time != null && state.app.expiration_time > Math.round(new Date().getTime()/1000),
    };
};
export default connect(mapStateToProps, {})(withRouter(Header))
